<!--
//================================================================================
// ID:BC021
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC021
//
// <<Modification History>>
// Version  | Date       | Updated By			| Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2023/11/09 | 富士通Japan株式会社	 | 新規作成
//================================================================================
-->
<template>
	<main class="contents__main">
		<div v-if="co_isIE()" class="contents__main--mosikomi" />
		<error-message />
		<div>
			<h2 class="contents__h2 h2-margintop">利用者情報</h2>
			<section>
				<table class="contents__table--stripe detail">
					<tbody>
						<!-- <tr>
							<th class="th-border"></th>
							<td class="td-topSpace border-bottom-none">
								<div class="mycheckbox checkBox-marginBottom">
									<check-box :classDiv="'position-checkBox'" :modelValue="form.riyosyaCheckbox"
										:name="'利用者/フリガナを変更する場合はチェックしてください'" :groupId="'fgRiyosya'"
										:listItems="disp.riyosyaList" @update:modelValue="form.riyosyaCheckbox = $event"
										ref="fgRiyosya" tabindex="1" />
								</div>
							</td>
						</tr> -->
						<tr class="contents__input--tr background__color--white">
							<th class="contents__input--title th-border th-paddingtop">
								利用者<span class="contents__hissu" v-show="disp.changeRiyosyaNameHissu">必須</span>
							</th>
							<td class="td-border">
								<div id="contents--name__area">
									<div>
										<label>
											氏：{{ form.nmName1Lbl }}
										</label>
										<br class="disp_br">
										<label class="margin-nameSpace">
											名：{{ form.nmName2Lbl }}
										</label>
									</div>
								</div>
								<div v-show="disp.changeRiyousyaName">
									<div id="contents--name__area">
										<div>
											氏：
											<text-input class="contents__input--text margin-Name width-name"
												style="ime-mode: active" :modelValue="form.nmName1"
												:textType="TEXTINPUT_TYPE.FULL" :maxLength="15" :name="'利用者（氏）'"
												:groupId="'riyosyaInfo'" :placeholder="'例）東京'" :requireFlg="true"
												@update:modelValue="form.nmName1 = $event" ref="nmName1" tabindex="2" />
										</div>
										<div>
											名：
											<text-input class="contents__input--text margin-Name width-name"
												style="ime-mode: active" :modelValue="form.nmName2"
												:textType="TEXTINPUT_TYPE.FULL" :maxLength="15" :name="'利用者（名）'"
												:groupId="'riyosyaInfo'" :placeholder="'例）太郎'" :requireFlg="true"
												@update:modelValue="form.nmName2 = $event" ref="nmName2" tabindex="3" />
										</div>
									</div>
									<itemerror-message :groupId="'riyosyaInfo'" />
								</div>
							</td>
						</tr>
						<tr class="background__color--white">
							<th class="contents__input--title">
								フリガナ<span class="contents__hissu" v-show="disp.changeRiyosyaHuriganaHissu">必須</span>
							</th>
							<td class="td-bottomSpace">
								<div id="contents--name__area">
									<div>
										<label>
											氏：{{ form.nmKana1Lbl }}
										</label>
										<br class="disp_br">
										<label class="margin-nameSpace">
											名：{{ form.nmKana2Lbl }}
										</label>
									</div>
								</div>
								<div v-show="disp.yesChangeRiyosyaHurigana">
									<div id="contents--name__area">
										<div>
											氏：
											<text-input class="contents__input--text margin-Name width-name"
												style="ime-mode: active" :modelValue="form.nmKana1"
												:textType="TEXTINPUT_TYPE.HALF_KANA" :maxLength="30" :name="'フリガナ（氏）'"
												:groupId="'huriganaInfo'" :placeholder="'例）ﾄｳｷｮｳ'" :requireFlg="true"
												@update:modelValue="form.nmKana1 = $event" ref="nmKana1" tabindex="4" />
										</div>
										<div>
											名：
											<text-input class="contents__input--text margin-Name width-name"
												style="ime-mode: active" :modelValue="form.nmKana2"
												:textType="TEXTINPUT_TYPE.HALF_KANA" :maxLength="30" :name="'フリガナ（名）'"
												:groupId="'huriganaInfo'" :placeholder="'例）ﾀﾛｳ'" :requireFlg="true"
												@update:modelValue="form.nmKana2 = $event" ref="nmKana2" tabindex="5" />
										</div>
									</div>
									<itemerror-message :groupId="'huriganaInfo'" />
									<div class="contents__caution--div div-lineheight margin-nameKana">
										<div class="contents__caution--div_mark">
											<p class="contents__caution contents__caution--multiple">
												<label>※</label>
											</p>
										</div>
										<div>
											<p class="contents__caution contents__caution--multiple">
												<label>カタカナで入力してください。</label>
											</p>
										</div>
									</div>
								</div>
							</td>
						</tr>
						<!-- <tr>
							<th class="th-border"></th>
							<td class="td-topSpace border-bottom-none">
								<div>
									<check-box :classDiv="'position-checkBox checkBox-marginBottom'"
										:modelValue="form.tusyomeiCheckbox" :name="'日本での通称名/フリガナを変更する場合はチェックしてください'"
										:groupId="'fgTusyomei'" :listItems="disp.tusyomeiList"
										@update:modelValue="form.tusyomeiCheckbox = $event" ref="fgTusyomei" tabindex="6" />
								</div>
							</td>
						</tr> -->
						<tr class="contents__input--tr background__color--light-gray">
							<th class="contents__input--title th-border th-paddingtop">
								日本での通称名
							</th>
							<td class="td-border">
								<div id="contents--name__area" v-show="disp.tusyonameLbl">
									<div>
										<label>
											氏：{{ form.nmTusyoname1Lbl }}
										</label>
										<br class="disp_br">
										<label class="margin-nameSpace">
											名：{{ form.nmTusyoname2Lbl }}
										</label>
									</div>
								</div>
								<div v-show="disp.yesChangebTusyoName">
									<div id="contents--name__area">
										<div>
											氏：
											<text-input class="contents__input--text margin-Name width-name"
												style="ime-mode: active" :modelValue="form.nmTusyoname1"
												:textType="TEXTINPUT_TYPE.FULL" :maxLength="15" :name="'通称名（氏）'"
												:groupId="'tusyomeiInfo'" :placeholder="'例）東'"
												@update:modelValue="form.nmTusyoname1 = $event" ref="nmTusyoname1"
												tabindex="7" />
										</div>
										<div>
											名：
											<text-input class="contents__input--text margin-Name width-name"
												style="ime-mode: active" :modelValue="form.nmTusyoname2"
												:textType="TEXTINPUT_TYPE.FULL" :maxLength="15" :name="'通称名（名）'"
												:groupId="'tusyomeiInfo'" :placeholder="'例）太郎'"
												@update:modelValue="form.nmTusyoname2 = $event" ref="nmTusyoname2"
												tabindex="8" />
										</div>
									</div>
									<itemerror-message :groupId="'tusyomeiInfo'" />
								</div>
							</td>
						</tr>
						<tr class="background__color--light-gray">
							<th class="contents__input--title">フリガナ</th>
							<td class="td-bottomSpace">
								<div id="contents--name__area" v-show="disp.tusyokanaLbl">
									<div>
										<label>
											氏：{{ form.nmTusyokana1Lbl }}
										</label>
										<br class="disp_br">
										<label class="margin-nameSpace">
											名：{{ form.nmTusyokana2Lbl }}
										</label>
									</div>
								</div>
								<div v-show="disp.yesChangebTusyoHurigana">
									<div id="contents--name__area">
										<div>
											氏：
											<text-input class="contents__input--text margin-Name width-name"
												style="ime-mode: active" :modelValue="form.nmTusyokana1"
												:textType="TEXTINPUT_TYPE.HALF_KANA" :maxLength="30" :name="'フリガナ（氏）'"
												:groupId="'tusyohuriganaInfo'" :placeholder="'例）ﾄｳ'"
												@update:modelValue="form.nmTusyokana1 = $event" ref="nmTusyokana1"
												tabindex="9" />
										</div>
										<div>
											名：
											<text-input class="contents__input--text margin-Name width-name"
												style="ime-mode: active" :modelValue="form.nmTusyokana2"
												:textType="TEXTINPUT_TYPE.HALF_KANA" :maxLength="30" :name="'フリガナ（名）'"
												:groupId="'tusyohuriganaInfo'" :placeholder="'例）ﾀﾛｳ'"
												@update:modelValue="form.nmTusyokana2 = $event" ref="nmTusyokana2"
												tabindex="10" />
										</div>
									</div>
									<itemerror-message :groupId="'tusyohuriganaInfo'" />
									<div class="contents__caution--div div-lineheight margin-tusyoKana">
										<div class="contents__caution--div_mark">
											<p class="contents__caution contents__caution--multiple">
												<label>※</label>
											</p>
										</div>
										<div>
											<p class="contents__caution contents__caution--multiple">
												<label>カタカナで入力してください。</label>
											</p>
										</div>
									</div>
									<div class="div-tyuiBun-fontSize margin-tusyoKanaTyui">
										<caution-message :tyuibunItems="disp.tusyomeiItems" />
									</div>
								</div>
							</td>
						</tr>
						<!-- <tr>
							<th class="th-border"></th>
							<td class="td-topSpace border-bottom-none">
								<div>
									<check-box :classDiv="'position-checkBox checkBox-marginBottom'"
										:modelValue="form.seinengappiCheckbox" :name="'生年月日を変更する場合はチェックしてください'"
										:groupId="'fgSeinengappi'" :listItems="disp.seinengappiList"
										@update:modelValue="form.seinengappiCheckbox = $event" ref="fgSeinengappi"
										tabindex="11" />
								</div>
							</td>
						</tr> -->
						<tr class="contents__input--tr background__color--white">
							<th class="contents__input--title th-paddingtop">
								生年月日<span class="contents__hissu" v-show="disp.changebBirthDayHissu">必須</span>
							</th>
							<td class="td-bottomSpace">
								<label>{{ form.yearValue }}年{{ form.monthValue }}月{{ form.dayValue }}日</label>
								<div class="div-marginTop10" v-show="disp.yesChangebBirthDay">
									<date-input :modelValue="form.dtBirthday" :name="'生年月日'" :groupId="'seinengapiInfo'"
										:requireFlg="true" :dateType="DATE_KIND.BIRTHDAY"
										@update:modelValue="changeBirthdayList" ref="dtBirthday" tabindex="12" />
									<itemerror-message :groupId="'seinengapiInfo'" />
									<div class="BirthDay-margin-bottom" />
								</div>
								<div>
									<caution-message :tyuibunItems="disp.seinengappiItems" />
								</div>
							</td>
						</tr>
						<!-- <tr class="background__color--white" v-show="disp.yesChangebBirthDayTr">
							<th class="contents__input--title border-bottom-none"></th>
							<td class="td-paddingtop td-bottomSpace border-bottom-none">
								<div class="div-seinengappiItems div-marginBottom">
									<caution-message :tyuibunItems="disp.seinengappiItems" />
								</div>
							</td>
						</tr> -->
						<!-- <tr>
							<th class="th-border bordeTop-th"></th>
							<td class="bordeTop-tb td-topSpace border-bottom-none">
								<div>
									<check-box :classDiv="'position-checkBox checkBox-marginBottom'"
										:modelValue="form.zipJusyoCheckbox" :name="'郵便番号/現住所を変更する場合はチェックしてください'"
										:groupId="'fgZipJusyo'" :listItems="disp.zipJusyoList"
										@update:modelValue="form.zipJusyoCheckbox = $event" ref="fgZipJusyo"
										tabindex="15" />
								</div>
							</td>
						</tr> -->
						<tr class="background__color--light-gray">
							<th class="contents__input--title th-paddingtop">
								郵便番号/現住所<span class="contents__hissu" v-show="disp.changeZipNumberJusyoHissu">必須</span>
							</th>
							<td class="td-bottomSpace">
								<div>
									{{ form.idZip1Lbl }} - {{ form.idZip2Lbl }}
								</div>
								<div class="margin-jyusyo">
									{{ form.txNowadr1Lbl }}
								</div>
								<div class="margin-jyusyo">
									{{ form.txNowadr2Lbl }}
								</div>
								<div class="margin-jyusyo">
									{{ form.txNowadr3Lbl }}
								</div>
								<div class="div-marginTop10" v-show="disp.yesChangeZipNumberJusyo">
									<number-input class="contents__input--text width-zip1" :modelValue="form.idZip1"
										:numberType="NUMBERINPUT_TYPE.NON_PERIOD" :name="'郵便番号（上３桁）'" :groupId="'zipInfo'"
										:maxLength="3" :placeholder="'例）001'" :requireFlg="true"
										@update:modelValue="changeZip1" ref="idZip1" tabindex="16" />&nbsp;-&nbsp;
									<number-input class="contents__input--text width-zip2" :modelValue="form.idZip2"
										:numberType="NUMBERINPUT_TYPE.NON_PERIOD" :name="'郵便番号（下４桁）'" :groupId="'zipInfo'"
										:maxLength="4" :placeholder="'例）0001'" :requireFlg="true"
										@update:modelValue="changeZip2" ref="idZip2" tabindex="17" />
									<input type="submit" value="住所検索" class="contents__btn--normal_jyusyo btn-jyusyokensaku"
										@click="searchJusyo" tabindex="18" />
									<itemerror-message :groupId="'zipInfo'" />
									<div>
										<label class="contents__caution">
											※数字で入力してください。
										</label>
									</div>
								</div>
								<div>
									<caution-message :tyuibunItems="disp.yubinbangoItems" />
								</div>
							</td>
						</tr>
						<tr v-show="disp.changeZipNumberJusyoTr1">
							<th class="contents__input--title th-paddingtop border-bottom-none" rowspan="3">
							</th>
							<td class="td-genjusyomargin td-border jusyo1-padding">
								<text-input class="contents__input--text width-genjusyo" :modelValue="form.txNowadr1"
									:textType="TEXTINPUT_TYPE.FULL" :name="'現住所１'" :groupId="'jusyoInfo'" :maxLength="20"
									:placeholder="'例）東京都新宿区西新宿５丁目〇〇－〇〇'" :requireFlg="true"
									@update:modelValue="form.txNowadr1 = $event" ref="txNowadr1" tabindex="19" />
							</td>
						</tr>
						<tr v-show="disp.changeZipNumberJusyoTr2">
							<td class="td-border background__color--light-gray jusyo2-padding">
								<text-input class="contents__input--text width-genjusyo" :modelValue="form.txNowadr2"
									:textType="TEXTINPUT_TYPE.FULL" :name="'現住所２'" :groupId="'jusyoInfo'" :maxLength="20"
									:placeholder="'例）▢▢▢ビル９９９号室'" @update:modelValue="form.txNowadr2 = $event"
									ref="txNowadr2" tabindex="20" />
							</td>
						</tr>
						<tr v-show="disp.changeZipNumberJusyoTr3">
							<td class="td-isIE td-bottomSpace border-bottom-none jusyo2-padding">
								<text-input class="contents__input--text width-genjusyo" :modelValue="form.txNowadr3"
									:textType="TEXTINPUT_TYPE.FULL" :name="'現住所３'" :groupId="'jusyoInfo'" :maxLength="20"
									:placeholder="'例）〇〇様方'" @update:modelValue="form.txNowadr3 = $event" ref="txNowadr3"
									tabindex="21" />
								<itemerror-message :groupId="'jusyoInfo'" />
								<div
									class="contents__caution--div div-lineheight div-jusyoMargin div-marginBottom jusyo-marginTop">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											<label>※</label>
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											<label>現住所は建物名まで必ず入力してください。</label>
										</p>
									</div>
								</div>
							</td>
						</tr>
						<!-- <tr>
							<th class="th-border bordeTop-th"></th>
							<td class="td-border bordeTop-tb td-topSpace">
								<div>
									<check-box :classDiv="'position-checkBox checkBox-marginBottom'"
										:modelValue="form.phoneCheckbox" :name="'電話番号を変更する場合はチェックしてください'"
										:groupId="'fgPhone'" :listItems="disp.phoneList"
										@update:modelValue="form.phoneCheckbox = $event" ref="fgPhone" tabindex="22" />
								</div>
							</td>
						</tr> -->
						<tr class="background__color--white">
							<th class="contents__input--title th-paddingtop">
								電話番号<span class="contents__hissu" v-show="disp.changePhoneHissu">必須</span>
							</th>
							<td class="td-bottomSpace">
								<label>{{ form.idTel1Lbl }} - {{ form.idTel2Lbl }} - {{ form.idTel3Lbl }}</label>
								<div v-show="disp.yesChangePhoneNumber">
									<number-input class="contents__input--text width-phone1" :modelValue="form.idTel1"
										:numberType="NUMBERINPUT_TYPE.NON_PERIOD" :name="'電話番号（市外）'" :groupId="'telInfo'"
										:maxLength="5" :requireFlg="true" @update:modelValue="form.idTel1 = $event"
										ref="idTel1" tabindex="23" />&nbsp;-&nbsp;
									<number-input class="contents__input--text width-phone" :modelValue="form.idTel2"
										:numberType="NUMBERINPUT_TYPE.NON_PERIOD" :name="'電話番号（市内）'" :groupId="'telInfo'"
										:maxLength="4" :requireFlg="true" @update:modelValue="form.idTel2 = $event"
										ref="idTel2" tabindex="24" />&nbsp;-&nbsp;
									<number-input class="contents__input--text width-phone" :modelValue="form.idTel3"
										:numberType="NUMBERINPUT_TYPE.NON_PERIOD" :name="'電話番号（局番）'" :groupId="'telInfo'"
										:maxLength="4" :requireFlg="true" @update:modelValue="form.idTel3 = $event"
										ref="idTel3" tabindex="25" />
									<itemerror-message :groupId="'telInfo'" />
								</div>
							</td>
						</tr>
						<tr v-show="disp.yesChangePhoneNumberTr" class="background__color--white">
							<th class="contents__input--title border-bottom-none"></th>
							<td class="td-paddingtop td-bottomSpace border-bottom-none">
								<div class="contents__caution--div div-lineheight div-marginBottom">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											<label>※</label>
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											<label>平日の日中に連絡のつく電話番号を入力してください。</label>
										</p>
									</div>
								</div>
							</td>
						</tr>
						<!-- <tr>
							<th class="th-border bordeTop-th"></th>
							<td class="td-border bordeTop-tb td-topSpace">
								<div>
									<check-box :classDiv="'position-checkBox checkBox-marginBottom'"
										:modelValue="form.passCheckbox" :name="'パスワードを変更する場合はチェックしてください'"
										:groupId="'fgPass'" :listItems="disp.passList"
										@update:modelValue="form.passCheckbox = $event" ref="fgPass" tabindex="26" />
								</div>
							</td>
						</tr> -->
						<tr class="contents__input--tr background__color--light-gray">
							<th class="contents__input--title th-border th-paddingtop">
								パスワード<span class="contents__hissu" v-show="disp.changePassHissu">必須</span>
							</th>
							<td class="td-border">
								<div class="margin-pass">
									<label>**************</label>
								</div>
							</td>
						</tr>
						<tr v-show="disp.changePass">
							<th class="th-border"></th>
							<td class="td-border">
								<div>
									<div>
										<password-input :modelValue="form.idPassword" :maxLength="14" :name="'パスワード'"
											:groupId="'passInfo'" :requireFlg="true" :formatCheckFlg="true"
											@update:modelValue="form.idPassword = $event" ref="idPassword" tabindex="27" />
									</div>
								</div>
							</td>
						</tr>
						<tr class="background__color--light-gray" v-show="disp.passwordChangeTr">
							<th class="contents__div--PC th-border"></th>
							<th
								class="contents__input--title th-border contents__div--MOBILE th-lineheight pass-padding-top">
								確認のため、再度パスワードを入力してください。<span class="spam-hissureigai">必須</span>
								<div>
									<label class="label-normal">
										(コピー・貼り付けはしないでください。)
									</label>
								</div>
							</th>
							<td class="td-border">
								<div>
									<password-input :modelValue="form.idPasswordKakunin" :maxLength="14"
										:name="'パスワード（確認用）'" :groupId="'passInfo'" :requireFlg="true" :formatCheckFlg="true"
										:pasteBanFlg="true" @update:modelValue="form.idPasswordKakunin = $event"
										ref="idPasswordKakunin" tabindex="28" />
								</div>
							</td>
						</tr>
						<tr class="contents__div--MOBILE background__color--light-gray" v-show="disp.passwordChangeTr2">
							<th class="contents__input--title th-border"></th>
							<td class="td-border">
								<div class="div-passtyuibun">
									<itemerror-message :groupId="'passInfo'" />
								</div>
							</td>
						</tr>
						<tr class="contents__div--PC background__color--light-gray" v-show="disp.passwordChangeTr2">
							<th class="contents__input--title th-border"></th>
							<td class="td-border">
								<div class="div-passtyuibun">
									<itemerror-message :groupId="'passInfo'" />
								</div>
								<div class="contents__caution--div div-lineheight">
									<div class="contents__caution--div_mark">
										<p class="contents__caution contents__caution--multiple">
											<label>※</label>
										</p>
									</div>
									<div>
										<p class="contents__caution contents__caution--multiple">
											<label>確認のため、もう一度入力してください。<br />（コピー・貼り付けはしないでください。）</label>
										</p>
									</div>
								</div>
							</td>
						</tr>
						<tr class="background__color--light-gray">
							<th class="contents__input--title th-passtyui th-border" colspan="2">
								<div v-show="disp.passwordChangeTr4">
									<div class="contents__caution--div div_row">
										<div class="contents__caution--div_mark">
											<p class="contents__caution contents__caution--multiple p-positiontop">
												※
											</p>
										</div>
										<div>
											<p class="contents__caution contents__caution--multiple p-positiontop">
												パスワードは以下の条件で入力してください。
											</p>
										</div>
									</div>
									<div class="contents__caution--div div_row div-marginleft div-passJoken">
										<div class="contents__caution--div_mark">
											<p class="contents__caution contents__caution--multiple p-positiontop">
												・
											</p>
										</div>
										<div>
											<p
												class="contents__caution contents__caution--multiple p-positiontop div-passJoken">
												8文字以上15文字未満
											</p>
										</div>
									</div>
									<div class="contents__caution--div div_row div-marginleft div-passJoken">
										<div class="contents__caution--div_mark">
											<p class="contents__caution contents__caution--multiple p-positiontop">
												・
											</p>
										</div>
										<div>
											<p
												class="contents__caution contents__caution--multiple p-positiontop div-passJoken">
												使用可能な文字は半角数字・半角英大文字・半角英小文字
											</p>
										</div>
									</div>
									<div
										class="contents__caution--div div_row div-marginleft div-passJoken div-marginBottom">
										<div class="contents__caution--div_mark">
											<p class="contents__caution contents__caution--multiple p-positiontop">
												・
											</p>
										</div>
										<div>
											<p
												class="contents__caution contents__caution--multiple p-positiontop div-passJoken">
												必ず半角数字・半角英大文字・半角英小文字をそれぞれ1文字以上混在させてください。
											</p>
										</div>
									</div>
								</div>
							</th>
						</tr>
						<tr class="background__color--light-gray" v-show="disp.passwordChangeTr3">
							<th class="contents__input--title th-border"></th>
							<td class="td-border td-bottomSpace padding-tyuiSpace">
								<div class="div-lineheight">
									<label id="label2" class="label-color">【注意】変更したパスワードは、変更完了後のログインで必要になります。<br><span
											class="span-marginLeft">大切に保管してください。</span></label>
								</div>
							</td>
						</tr>
						<tr class="background__color--white">
							<th class="contents__input--title th-border bordeTop-th bordedown-bottom">
								メールアドレス
							</th>
							<td class="bordeTop-tb td-topSpace">
								<label class="contents__kaigyo--css">{{ form.idMailaddress }}</label>
							</td>
						</tr>
					</tbody>
				</table>
				<br />
				<div class="contents__div--center margin__bottom-page">
					<input type="submit" value="変更を確定する" class="contents__btn--confirm btn-confirmmargin"
						@click="honTouroku" tabindex="29" />
					<input type="submit" value="終了" class="contents__btn--cancel btn-cancelmargin" @click="syuryo"
						tabindex="30" />
				</div>
				<br />
			</section>
		</div>
	</main>
</template>

<script>
import PasswordInput from '@/components/PasswordInput.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import TextInput from '@/components/TextInput.vue';
import NumberInput from '@/components/NumberInput.vue';
import DateInput from '@/components/DateInput.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import CautionMessage from '@/components/CautionMessage.vue';
// import CheckBox from '@/components/CheckBox.vue';

import { co_post, co_moveSystemError, co_put } from '@/common/ajaxUtility.js';
import { co_completedDialog, co_confirmDialog, co_errorDialog } from '@/common/dialogUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_calcAge, co_editDateSlash } from '@/common/stringUtility.js';
import { co_isIE, co_isOperation } from '@/common/browserUtility.js';
import { co_toTrans } from '@/common/screenUtility.js';
import { co_isEmpty } from '@/common/checkUtility.js';

import { NUMBERINPUT_TYPE, TEXTINPUT_TYPE, DATE_KIND, DIALOG_BUTTON_LIST_KEY, SEINENSYA_KIJUN_AGE } from '@/const/const.js';
import { STORE_ERROR_CLEAR, STORE_ERROR_IS_ERRFLG, STORE_ERROR_SET_INPUT_ERR, STORE_VIEW_PROGRESS, STORE_ERROR_DELETE_ID } from '@/const/store.js';
import { PATH_BC021_INIT, PATH_BC021_UPDATEINFO, PATH_BC021_UPDATECHECK, API_ADDRESS_INFO } from '@/const/route.js';
import { E3005 } from '@/const/messageId.js';

export default {
	name: "BC021",
	components: {
		'error-message': ErrorMessage,
		'text-input': TextInput,
		'number-input': NumberInput,
		'password-input': PasswordInput,
		'date-input': DateInput,
		'itemerror-message': ItemErrorMessage,
		'caution-message': CautionMessage,
		// 'check-box': CheckBox,
	},
	data: function () {
		return {
			form: {
				idRiyosya: "",				// 利用者番号
				noUketuke: "",				// 受付番号
				nmName1: "",				// 利用者氏名（氏）
				nmName2: "",				// 利用者氏名（名）
				nmKana1: "",				// フリガナ（氏）
				nmKana2: "",				// フリガナ（名）
				riyosyaCheckbox: '',		// 利用者/フリガナを変更する場合はチェックしてください
				nmTusyoname1: "",			// 通称氏名（氏）
				nmTusyoname2: "",			// 通称氏名（名）
				nmTusyokana1: "",			// 通称フリガナ（氏）
				nmTusyokana2: "",			// 通称フリガナ（名）
				tusyomeiCheckbox: '',		// 日本での通称名/フリガナを変更する場合はチェックしてください
				seinengappiCheckbox: '',	// 生年月日を変更する場合はチェックしてください
				yearValue: "",				// 生年月日（年）
				monthValue: "",				// 生年月日（月）
				dayValue: "",				// 生年月日（日）
				dtBirthday: "",				// 生年月日
				zipJusyoCheckbox: '',		// 郵便番号/現住所を変更する場合はチェックしてください
				idZip1: "",					// 郵便番号１
				idZip2: "",					// 郵便番号２
				txNowadr1: "",				// 現住所１
				txNowadr2: "",				// 現住所２
				txNowadr3: "",				// 現住所３
				phoneCheckbox: '',			// 電話番号を変更する場合はチェックしてください
				idTel1: "",					// 電話番号（市外）
				idTel2: "",					// 電話番号（市内）
				idTel3: "",					// 電話番号（局番）
				passCheckbox: '',			// パスワードを変更する場合はチェックしてください
				idPassword: "",				// パスワード
				idPasswordKakunin: "",		// パスワード（確認用）
				idMailaddress: "",			// メールアドレス
			},
			disp: {
				riyosyaList: [],					// 利用者氏名フリガナの変更
				changeRiyosyaNameHissu: false,		// 利用者氏名の必須マーク制御
				changeRiyousyaName: false,			// 利用者氏名項目制御
				changeRiyosyaHuriganaHissu: false,	// 利用者フリガナの必須マーク制御
				yesChangeRiyosyaHurigana: false,	// 利用者フリガナ項目制御
				tusyonameLbl: false,				// 日本での通称名（表示用）制御
				tusyokanaLbl: false,				// 日本での通称名フリガナ（表示用）制御
				tusyomeiList: [],					// 日本での通称名フリガナの変更
				yesChangebTusyoName: false,			// 日本での通称名項目制御
				yesChangebTusyoHurigana: false,		// 日本での通称名フリガナ項目制御
				seinengappiList: [],				// 生年月日の変更
				changebBirthDayHissu: false,		// 生年月日の必須マーク制御
				yesChangebBirthDay: false,			// 生年月日項目制御
				yesChangebBirthDayTr: false,		// 生年月日注意文制御
				zipJusyoList: [],					// 郵便番号/現住所の変更
				changeZipNumberJusyoHissu: false,	// 郵便番号/現住所の必須マーク制御
				yesChangeZipNumberJusyo: false,		// 郵便番号項目制御
				changeZipNumberJusyoTr1: false,		// 現住所１項目制御
				changeZipNumberJusyoTr2: false,		// 現住所２項目制御
				changeZipNumberJusyoTr3: false,		// 現住所３項目制御
				phoneList: [],						// 電話番号の変更
				changePhoneHissu: false,			// 電話番号の必須マーク制御
				yesChangePhoneNumber: false,		// 電話番号項目制御
				yesChangePhoneNumberTr: false,		// 電話番号注意文制御
				passList: [],						// パスワードの変更
				changePassHissu: false,				// パスワードの必須マーク制御
				changePass: false,					// パスワード項目制御
				passwordChangeTr: false,			// パスワード（確認用）項目制御
				passwordChangeTr2: false,			// パスワード注意文制御１
				passwordChangeTr3: false,			// パスワード注意文制御２
				passwordChangeTr4: false,			// パスワード注意文（設定条件）制御
				tusyomeiItems: ['C0055'],			// 通称名注意文
				seinengappiItems: [],				// 未成年注意文
				yubinbangoItems: [],				// 郵便番号注意文
			},
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE,
			DATE_KIND: DATE_KIND,
			co_isIE: co_isIE
		};
	},
	mounted: async function () {
		await this.$nextTick();

		// 利用者氏名フリガナの変更
		this.disp.riyosyaList = [
			{ idCd: '1', nmCd: '利用者/フリガナを変更する場合はチェックしてください' }
		];

		// 日本での通称名フリガナの変更
		this.disp.tusyomeiList = [
			{ idCd: '1', nmCd: '日本での通称名/フリガナを変更する場合はチェックしてください' }
		];

		// 生年月日の変更
		this.disp.seinengappiList = [
			{ idCd: '1', nmCd: '生年月日を変更する場合はチェックしてください' }
		];

		// 郵便番号/現住所の変更
		this.disp.zipJusyoList = [
			{ idCd: '1', nmCd: '郵便番号/現住所を変更する場合はチェックしてください' }
		];

		// 電話番号の変更
		this.disp.phoneList = [
			{ idCd: '1', nmCd: '電話番号を変更する場合はチェックしてください' }
		];

		// パスワードの変更
		this.disp.passList = [
			{ idCd: '1', nmCd: 'パスワードを変更する場合はチェックしてください' }
		];

		// フォーカス設定
		this.$refs.fgRiyosya.focus();
	},
	created: async function () {

		// ブラウザチェック
		if (!await co_isOperation()) {
			co_toTrans('BrowserError');
			return;
		}

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// URLから受付番号、受付日を取得
		let angouNumber = {
			'angouNumber': this.$route.fullPath.replace('/BC021?', '')
		};
		// 初期値設定
		let initInfo = await co_post(PATH_BC021_INIT, angouNumber);
		if (co_isEmpty(initInfo)) {

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// システムエラー画面へ遷移
			co_moveSystemError([E3005]);
			return;
		}

		// 日本での通称名、フリガナ（表示用）制御
		if (co_isEmpty(initInfo.nmTusyoname1) && co_isEmpty(initInfo.nmTusyoname2)
			&& co_isEmpty(initInfo.nmTusyokana1) && co_isEmpty(initInfo.nmTusyokana2)) {
			this.disp.tusyonameLbl = false;
			this.disp.tusyokanaLbl = false;
		} else {
			this.disp.tusyonameLbl = true;
			this.disp.tusyokanaLbl = true;
		}

		// 郵便番号注意文表示制御
		let yubinbangoItems = new Array();
		let jyusyo = initInfo.txNowadr1;
		let tokyo = jyusyo.substring(0, 3);
		if (tokyo != "東京都") {
			yubinbangoItems.push('C0001');
			this.disp.yubinbangoItems = yubinbangoItems;
		}

		this.form.idRiyosya = initInfo.idRiyosya;
		this.form.noUketuke = initInfo.noUketuke;
		this.form.dtHenko = initInfo.dtHenko;
		this.form.idMailaddress = initInfo.idMailaddress;
		this.form.nmName1Lbl = initInfo.nmName1;
		this.form.nmName2Lbl = initInfo.nmName2;
		this.form.nmKana1Lbl = initInfo.nmKana1;
		this.form.nmKana2Lbl = initInfo.nmKana2;
		this.form.nmName1 = initInfo.nmName1;
		this.form.nmName2 = initInfo.nmName2;
		this.form.nmKana1 = initInfo.nmKana1;
		this.form.nmKana2 = initInfo.nmKana2;
		this.form.nmTusyoname1Lbl = initInfo.nmTusyoname1;
		this.form.nmTusyoname2Lbl = initInfo.nmTusyoname2;
		this.form.nmTusyokana1Lbl = initInfo.nmTusyokana1;
		this.form.nmTusyokana2Lbl = initInfo.nmTusyokana2;
		this.form.nmTusyoname1 = initInfo.nmTusyoname1;
		this.form.nmTusyoname2 = initInfo.nmTusyoname2;
		this.form.nmTusyokana1 = initInfo.nmTusyokana1;
		this.form.nmTusyokana2 = initInfo.nmTusyokana2;
		this.form.yearValue = initInfo.yrBirthday;
		this.form.monthValue = ('00' + initInfo.mtBirthday).slice(-2);
		this.form.dayValue = ('00' + initInfo.dyBirthday).slice(-2);
		this.form.dtBirthday = String(initInfo.dtBirthday);
		this.$refs.dtBirthday.setValue(this.form.dtBirthday);
		let yubinbango = initInfo.idZip.split('-');
		this.form.idZip1Lbl = yubinbango[0];
		this.form.idZip2Lbl = yubinbango[1];
		this.form.idZip1 = yubinbango[0];
		this.form.idZip2 = yubinbango[1];
		this.form.txNowadr1Lbl = initInfo.txNowadr1;
		this.form.txNowadr2Lbl = initInfo.txNowadr2;
		this.form.txNowadr3Lbl = initInfo.txNowadr3;
		this.form.txNowadr1 = initInfo.txNowadr1;
		this.form.txNowadr2 = initInfo.txNowadr2;
		this.form.txNowadr3 = initInfo.txNowadr3;
		let denwabango = initInfo.idTel.split('-');
		this.form.idTel1Lbl = denwabango[0];
		this.form.idTel2Lbl = denwabango[1];
		this.form.idTel3Lbl = denwabango[2];
		this.form.idTel1 = denwabango[0];
		this.form.idTel2 = denwabango[1];
		this.form.idTel3 = denwabango[2];

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	watch: {
		// 利用者氏名フリガナの変更
		'form.riyosyaCheckbox': async function () {
			if (this.form.riyosyaCheckbox == '1') {
				// エラークリア（赤枠クリア）
				this.$refs.nmName1.clearError();
				this.$refs.nmName2.clearError();
				this.$refs.nmKana1.clearError();
				this.$refs.nmKana2.clearError();
				this.disp.changeRiyosyaNameHissu = true;
				this.disp.changeRiyousyaName = true;
				this.disp.changeRiyosyaHuriganaHissu = true;
				this.disp.yesChangeRiyosyaHurigana = true;
			} else {
				this.disp.changeRiyosyaNameHissu = false;
				this.disp.changeRiyousyaName = false;
				this.disp.changeRiyosyaHuriganaHissu = false;
				this.disp.yesChangeRiyosyaHurigana = false;

				this.checkboxOffSyori("riyosyaInfo");
				this.checkboxOffSyori("huriganaInfo");

			}

			// 利用者氏名フリガナ 初期値設定
			this.form.nmName1 = this.form.nmName1Lbl;
			this.form.nmName2 = this.form.nmName2Lbl;
			this.form.nmKana1 = this.form.nmKana1Lbl;
			this.form.nmKana2 = this.form.nmKana2Lbl;

		},
		// 日本での通称名フリガナの変更
		'form.tusyomeiCheckbox': async function () {
			if (this.form.tusyomeiCheckbox == '1') {
				// エラークリア（赤枠クリア）
				this.$refs.nmTusyoname1.clearError();
				this.$refs.nmTusyoname2.clearError();
				this.$refs.nmTusyokana1.clearError();
				this.$refs.nmTusyokana2.clearError();
				this.disp.yesChangebTusyoName = true;
				this.disp.yesChangebTusyoHurigana = true;
			} else {
				this.disp.yesChangebTusyoName = false;
				this.disp.yesChangebTusyoHurigana = false;
				this.checkboxOffSyori("tusyomeiInfo");
				this.checkboxOffSyori("tusyohuriganaInfo");
			}

			// 通称名フリガナ 初期値設定
			this.form.nmTusyoname1 = this.form.nmTusyoname1Lbl;
			this.form.nmTusyoname2 = this.form.nmTusyoname2Lbl;
			this.form.nmTusyokana1 = this.form.nmTusyokana1Lbl;
			this.form.nmTusyokana2 = this.form.nmTusyokana2Lbl;
		},
		// 生年月日の変更
		'form.seinengappiCheckbox': async function () {
			if (this.form.seinengappiCheckbox == '1') {
				// エラークリア（赤枠クリア）
				this.$refs.dtBirthday.clearError();

				this.disp.changebBirthDayHissu = true;
				this.disp.yesChangebBirthDay = true;
				this.disp.yesChangebBirthDayTr = true;
			} else {
				this.disp.changebBirthDayHissu = false;
				this.disp.yesChangebBirthDay = false;
				this.disp.yesChangebBirthDayTr = false;
				this.checkboxOffSyori("seinengapiInfo");
			}

			// 生年月日 初期値設定
			this.form.dtBirthday = String(this.form.yearValue + this.form.monthValue + this.form.dayValue);
			this.$refs.dtBirthday.setValue(this.form.dtBirthday);
		},
		// 郵便番号/現住所の変更
		'form.zipJusyoCheckbox': async function () {
			if (this.form.zipJusyoCheckbox == '1') {
				// エラークリア（赤枠クリア）
				this.$refs.idZip1.clearError();
				this.$refs.idZip2.clearError();
				this.$refs.txNowadr1.clearError();
				this.$refs.txNowadr2.clearError();
				this.$refs.txNowadr3.clearError();

				this.disp.changeZipNumberJusyoHissu = true;
				this.disp.yesChangeZipNumberJusyo = true;
				this.disp.changeZipNumberJusyoTr1 = true;
				this.disp.changeZipNumberJusyoTr2 = true;
				this.disp.changeZipNumberJusyoTr3 = true;

				this.changeZip();

			} else {
				this.disp.changeZipNumberJusyoHissu = false;
				this.disp.yesChangeZipNumberJusyo = false;
				this.disp.changeZipNumberJusyoTr1 = false;
				this.disp.changeZipNumberJusyoTr2 = false;
				this.disp.changeZipNumberJusyoTr3 = false;
				this.checkboxOffSyori("zipInfo");
				this.checkboxOffSyori("jusyoInfo");
			}

			// 郵便番号/現住所 初期値設定
			this.form.idZip1 = this.form.idZip1Lbl;
			this.form.idZip2 = this.form.idZip2Lbl;
			this.form.txNowadr1 = this.form.txNowadr1Lbl;
			this.form.txNowadr2 = this.form.txNowadr2Lbl;
			this.form.txNowadr3 = this.form.txNowadr3Lbl;
		},
		// 電話番号の変更
		'form.phoneCheckbox': async function () {
			if (this.form.phoneCheckbox == '1') {
				// エラークリア（赤枠クリア）
				this.$refs.idTel1.clearError();
				this.$refs.idTel2.clearError();
				this.$refs.idTel3.clearError();
				this.disp.changePhoneHissu = true;
				this.disp.yesChangePhoneNumber = true;
				this.disp.yesChangePhoneNumberTr = true;
			} else {
				this.disp.changePhoneHissu = false;
				this.disp.yesChangePhoneNumber = false;
				this.disp.yesChangePhoneNumberTr = false;
				this.checkboxOffSyori("telInfo");
			}

			// 電話番号 初期値設定
			this.form.idTel1 = this.form.idTel1Lbl;
			this.form.idTel2 = this.form.idTel2Lbl;
			this.form.idTel3 = this.form.idTel3Lbl;
		},
		// パスワードの変更
		'form.passCheckbox': function () {
			if (this.form.passCheckbox == '1') {
				// エラークリア（赤枠クリア）
				this.$refs.idPassword.clearError();
				this.$refs.idPasswordKakunin.clearError();
				this.disp.changePassHissu = true;
				this.disp.changePass = true;
				this.disp.passwordChangeTr = true;
				this.disp.passwordChangeTr2 = true;
				this.disp.passwordChangeTr3 = true;
				this.disp.passwordChangeTr4 = true;
			} else {
				this.disp.changePassHissu = false;
				this.disp.changePass = false;
				this.disp.passwordChangeTr = false;
				this.disp.passwordChangeTr2 = false;
				this.disp.passwordChangeTr3 = false;
				this.disp.passwordChangeTr4 = false;
				this.checkboxOffSyori("passInfo");
			}

			// 初期化
			this.form.idPassword = "";
			this.form.idPasswordKakunin = "";
		},

	},
	methods: {
		// 未成年注意分設定
		changeBirthdayList: function (val) {
			this.form.dtBirthday = val;
			let seinengappiItems = new Array();
			let tanjobi = this.form.dtBirthday;

			// 有効な日付の場合
			if (this.validDate(val)) {
				if (tanjobi.length == 8) {
					let age = co_calcAge(tanjobi);
					if (age < SEINENSYA_KIJUN_AGE) {
						seinengappiItems.push('C0002');
					}
				}
			}
			this.disp.seinengappiItems = seinengappiItems;
		},
		changeZip1: function (val) {
			this.form.idZip1 = val;

			// 郵便番号注意分設定
			this.changeZip();
		},
		changeZip2: function (val) {
			this.form.idZip2 = val;

			// 郵便番号注意分設定
			this.changeZip();
		},
		// 郵便番号注意分設定
		changeZip: async function () {
			// 住所検索
			let zipCodeInfo = {
				'zipcode': this.form.idZip1 + this.form.idZip2,
			};
			let yubinbangoItems = new Array();
			let idZip = this.form.idZip1 + this.form.idZip2;
			let jyusyo = await co_post(API_ADDRESS_INFO, zipCodeInfo);
			let tokyo = jyusyo.substring(0, 3);
			if (idZip.length == 7) {
				if (tokyo != "東京都") {
					yubinbangoItems.push('C0001');
				}
			}
			this.disp.yubinbangoItems = yubinbangoItems;
		},
		// 変更を確定するボタン押下処理
		honTouroku: async function () {

			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 単項目チェック
			if (this.form.riyosyaCheckbox == "1") {
				this.$refs.nmName1.validate();
				this.$refs.nmName2.validate();
				this.$refs.nmKana1.validate();
				this.$refs.nmKana2.validate();
			}

			// 通称名、通称名フリガナチェック
			if (this.form.tusyomeiCheckbox == "1") {
				let tutyomeiNa = this.form.nmTusyoname1;
				let tusyomeiSi = this.form.nmTusyoname2;
				let tusyohuriganaNa = this.form.nmTusyokana1;
				let tusyohuriganaSi = this.form.nmTusyokana2;
				this.$refs.nmTusyoname1.validate();
				if (co_isEmpty(tutyomeiNa) && !co_isEmpty(tusyomeiSi)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, { id: 'tusyomeiInfo', msg: co_getMessage("E0011", '通称名（氏）') });
					this.$refs.nmTusyoname1.setError();
					this.$refs.nmTusyoname1.focus();
				}
				this.$refs.nmTusyoname2.validate();
				if (!co_isEmpty(tutyomeiNa) && co_isEmpty(tusyomeiSi)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, { id: 'tusyomeiInfo', msg: co_getMessage("E0011", '通称名（名）') });
					this.$refs.nmTusyoname2.setError();
					this.$refs.nmTusyoname2.focus();
				}
				let nmTusyoKana1 = this.$refs.nmTusyokana1.validate();
				if (co_isEmpty(tusyohuriganaNa) && !co_isEmpty(tusyohuriganaSi)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, { id: 'tusyohuriganaInfo', msg: co_getMessage("E0011", 'フリガナ（氏）') });
					this.$refs.nmTusyokana1.setError();
					this.$refs.nmTusyokana1.focus();
					// フォーカス制御
					if (co_isEmpty(tutyomeiNa) && !co_isEmpty(tusyomeiSi)) {
						this.$refs.nmTusyoname1.focus();
					} else if (co_isEmpty(tusyohuriganaNa) && !co_isEmpty(tusyohuriganaSi)) {
						this.$refs.nmTusyokana1.focus();
					}
				}
				this.$refs.nmTusyokana2.validate();
				if (!co_isEmpty(tusyohuriganaNa) && co_isEmpty(tusyohuriganaSi)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, { id: 'tusyohuriganaInfo', msg: co_getMessage("E0011", 'フリガナ（名）') });
					this.$refs.nmTusyokana2.setError();
					this.$refs.nmTusyokana2.focus();
					// フォーカス制御
					if (co_isEmpty(tutyomeiNa) && !co_isEmpty(tusyomeiSi)) {
						this.$refs.nmTusyokana1.focus();
					} else if (!co_isEmpty(tutyomeiNa)  && co_isEmpty(tusyomeiSi)) {
						this.$refs.nmTusyokana2.focus();
					} else if (nmTusyoKana1 == false) {
						this.$refs.nmTusyokana1.focus();
					}
				}
				if (!co_isEmpty(tutyomeiNa) && !co_isEmpty(tusyomeiSi) && co_isEmpty(tusyohuriganaNa) && co_isEmpty(tusyohuriganaSi)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, { id: 'tusyohuriganaInfo', msg: co_getMessage("E0011", '通称名フリガナ') });
					this.$refs.nmTusyokana1.setError();
					this.$refs.nmTusyokana2.setError();
					this.$refs.nmTusyokana1.focus();
				}
				if (co_isEmpty(tutyomeiNa) && co_isEmpty(tusyomeiSi) && !co_isEmpty(tusyohuriganaNa) && !co_isEmpty(tusyohuriganaSi)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, { id: 'tusyomeiInfo', msg: co_getMessage("E0011", '通称名') });
					this.$refs.nmTusyoname1.setError();
					this.$refs.nmTusyoname2.setError();
					this.$refs.nmTusyoname1.focus();
				}
			}
			if (this.form.seinengappiCheckbox == "1") {
				this.$refs.dtBirthday.validate();
			}
			if (this.form.zipJusyoCheckbox == "1") {
				this.$refs.idZip1.validate();
				this.$refs.idZip2.validate();
				if (this.$refs.txNowadr1.validate() == true) {
					// 現住所に区市町村がない場合
					let txNowadr = this.form.txNowadr1 + this.form.txNowadr2 + this.form.txNowadr3;
					let resultKu = txNowadr.indexOf('区');
					let resultSi = txNowadr.indexOf('市');
					let resultTyou = txNowadr.indexOf('町');
					let resultSon = txNowadr.indexOf('村');
					if (resultKu == -1 && resultSi == -1 && resultTyou == -1 && resultSon == -1) {
						this.$store.commit(STORE_ERROR_SET_INPUT_ERR, { id: 'jusyoInfo', msg: co_getMessage("E0008") });
						this.$refs.txNowadr1.setError();
						this.$refs.txNowadr2.setError();
						this.$refs.txNowadr3.setError();
					} else {
						this.$refs.txNowadr2.clearError();
						this.$refs.txNowadr3.clearError()
					}
				}
				this.$refs.txNowadr2.validate();
				this.$refs.txNowadr3.validate();
			}
			if (this.form.phoneCheckbox == "1") {
				this.$refs.idTel1.validate();
				this.$refs.idTel2.validate();
				this.$refs.idTel3.validate();
			}
			if (this.form.passCheckbox == "1") {
				this.$refs.idPassword.validate();
				this.$refs.idPasswordKakunin.validate();
			}

			if (this.form.passCheckbox == "1") {
				// パスワードとパスワード（確認用）が同一ではない場合
				if (this.form.idPassword != this.form.idPasswordKakunin) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, { id: 'passInfo', msg: co_getMessage("E0007") });
					this.$refs.idPassword.setError();
					this.$refs.idPasswordKakunin.setError();
				}
			}

			// 入力チェックエラーが存在しない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {

				co_confirmDialog(co_getMessage("W0027"), this.doHonTouroku);

			}
		},
		// 確認ダイアログ「はい」ボタン押下時処理
		doHonTouroku: async function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				// 利用者仮変更 更新前チェック
				let errCode = await co_post(PATH_BC021_UPDATECHECK, this.form);
				// エラーコードが設定されていた場合
				if (!co_isEmpty(errCode)) {
					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);
					co_errorDialog(co_getMessage(errCode), this.existErr);
					return;
				}
				// 更新処理呼び出し
				await co_put(PATH_BC021_UPDATEINFO, this.form);

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// return;
				co_completedDialog(co_getMessage("I0012"), this.doClose);

			}
		},
		// 利用者情報存在チェックエラーダイアログ「OK」ボタン押下時処理
		existErr: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},
		// 完了ダイアログ「はい」ボタン押下時処理
		doClose: function () {
			window.location.href = 'https://www.juutakuseisaku.metro.tokyo.lg.jp/toei_online/index.html';
		},
		// 終了ボタン押下時処理
		syuryo: async function () {
			// 確認ダイアログ表示
			co_confirmDialog(co_getMessage("W0012"), this.doSyuryo);
			return;
		},
		// 確認ダイアログ「はい」ボタン押下時処理
		doSyuryo: async function (flg) {
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				window.location.href = 'https://www.juutakuseisaku.metro.tokyo.lg.jp/toei_online/index.html';
			}
			// ダイアログ「いいえ」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.CANCEL) {
				// ダイアログを閉じる
				return;
			}
		},
		// 住所検索ボタン押下時処理
		searchJusyo: async function () {
			// 住所検索
			let zipCodeInfo = {
				'zipcode': this.form.idZip1 + this.form.idZip2,
			};
			let jyusyo = await co_post(API_ADDRESS_INFO, zipCodeInfo);
			// 現住所１に設定する
			this.form.txNowadr1 = jyusyo;
		},
		// チェックボックスOFF時処理
		checkboxOffSyori: function (id) {
			// 各項目 エラーメッセージクリア
			this.$store.commit(STORE_ERROR_DELETE_ID, id );
		},
		// 有効日付チェック
		validDate: function (val) {
			let isValidDate = true;
			let monthValue = val.substring(4, 6);
			const date = new Date(co_editDateSlash(val));
			let dateMonth = date.getMonth() + 1;
			let checkMonth = dateMonth.toString().padStart(2, "0");
			// 入力した月とシステム日付の月がズレていた場合
			if (checkMonth != monthValue) {
				isValidDate = false;
			}
			return (isValidDate);
		},
	},
};
</script>

<style scoped>
.h2-margintop {
	margin-top: 7px;
}

.th-paddingtop {
	padding-top: 10px;
}

.th-border {
	border-bottom: none;
}

.td-paddingtop {
	padding-top: 1px;
}

.td-border {
	border-bottom: none;
}

.label-normal {
	font-weight: normal;
}

.p-positiontop {
	position: relative;
	top: -5px;
	color: #262626;
}

.div-marginleft {
	margin-left: 15px;
}

.margin-nameSpace {
	margin-left: 11px;
}

.width-phone {
	text-align: left;
}

.width-zip1 {
	text-align: left;
}

.width-zip2 {
	text-align: left;
}

.btn-jyusyokensaku {
	left: 3%;
}

.div-lineheight {
	line-height: 1.3em !important;
}

.jusyo-marginTop {
	margin-top: 7px;
}

.border-bottom-none {
	border-bottom: none;
}

.pass-padding-top {
	padding-top: 20px;
}

.BirthDay-margin-bottom {
	margin-bottom: 5px;
}

.jusyo1-padding {
	padding: 10px 10px 5px !important;
}

.jusyo2-padding {
	padding: 5px 10px 5px !important;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.contents__main {
		font-size: 16px;
	}

	.position-checkBox {
		position: relative;
		right: 15px;
	}

	.checkBox-marginBottom {
		margin-bottom: -20px;
	}

	.marginBottom5px-checkBox {
		margin-bottom: 5px;
	}

	.bordeTop-th {
		border-top: 1px dashed #aaaaaa;
	}

	.bordedown-bottom {
		border-bottom: 1px dashed #aaaaaa;
	}

	.bordeTop-tb {
		border-top: 1px dashed #aaaaaa;
	}

	.div-marginTop10 {
		margin-top: 10px;
	}

	.width-phone1 {
		width: 9% !important;
		text-align: left;
	}

	.width-zip1 {
		width: 12%;
	}

	.width-zip2 {
		width: 14%;
	}

	.width-genjusyo {
		width: 73%;
	}

	.th-passtyui {
		padding: 0px 10px 5px;
		font-weight: normal;
		font-size: 15px;
		line-height: 1em;
	}

	.btn-confirmmargin {
		margin-bottom: 2%;
		margin-right: 50px;
	}

	.btn-cancelmargin {
		margin-bottom: 2%;
		margin-left: 50px;
	}

	.margin-nameKana {
		margin-top: 5px;
		margin-bottom: 10px;
	}

	.margin-tusyoKana {
		margin-top: 5px;
	}

	.margin-tusyoKanaTyui {
		margin-bottom: 10px;
	}

	.div-jusyoMargin {
		margin-bottom: 10px;
	}

	.div-passJoken {
		margin-top: 5px !important;
	}

	.div-marginBottom {
		margin-bottom: 10px;
	}

	.td-passTyui {
		padding-top: 0px;
	}

	.label-color {
		color: red !important;
		font-weight: bold;
	}

	.span-marginLeft {
		margin-left: 63px;
	}

	.div-marginTop5px {
		margin-top: 7px;
		margin-bottom: 7px;
	}

	.margin-pass {
		margin-top: 5px;
		margin-bottom: -5px;
	}

	.div-passtyuibun {
		margin-top: -20px;
	}

	.disp_br {
		display: none;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.contents__main {
		font-size: 18px;
	}

	.contents__h2 {
		font-size: 18px;
	}

	.position-checkBox {
		position: relative;
		right: 15px;
		line-height: 1.6em;
		width: 101%;
	}

	.margin-nameKana,
	.margin-tusyoKana {
		margin-bottom: 10px;
	}

	.margin-tusyoKanaTyui {
		margin-top: -10px;
		margin-bottom: 10px;
	}

	.checkBox-marginBottom {
		margin-top: 7px;
	}

	.td-topSpace {
		padding-top: 5px !important;
	}

	.td-bottomSpace {
		padding-bottom: 10px !important;
	}

	.bordeTop-th {
		border-top: 1px dashed #aaaaaa;
	}

	.bordeTop-bottom {
		border-bottom: none;
	}

	.contents__hissu {
		bottom: 10px;
		right: auto;
	}

	.spam-hissureigai {
		background-color: #e00;
		color: #fff;
		font-size: 12px;
		margin: 5px 0;
		padding: 2px 2px;
		border-radius: 3px;
		position: absolute;
		line-height: 1.3em;
	}

	.contents__table--stripe td,
	.contents__table--stripe th {
		padding: 0px 10px 0px;
	}

	.contents__caution--div {
		line-height: 1.5em;
	}

	.contents__caution {
		font-size: 18px;
		display: inline;
	}

	.div-margintop {
		margin-top: -10px;
	}

	.width-zip1 {
		width: 23%;
	}

	.width-zip2 {
		width: 26%;
	}

	.margin-jyusyo {
		margin-top: -5px;
	}

	.td-genjusyomargin {
		margin-top: -8px;
	}

	.width-genjusyo {
		width: 94%;
	}

	.th-passtyui {
		padding: 0px 10px 5px;
		font-weight: normal;
		font-size: 15px;
		margin-top: 15px;
	}

	.th-lineheight {
		line-height: 1.5em;
	}

	.btn-confirmmargin {
		margin-right: 35px;
	}

	.div-tyuiBun-fontSize {
		font-size: 19.6506px;
	}

	.div-passJoken {
		line-height: 1em !important;
	}

	.margin-Name {
		margin-bottom: 10px;
	}

	.label-color {
		color: red !important;
		font-weight: bold;
	}

	.div-marginTop5px {
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.width-phone1 {
		width: 19% !important;
		text-align: left !important;
	}

	.padding-tyuiSpace {
		padding-top: 10px !important;
	}

	.disp_br {
		display: block;
	}

	.margin-nameSpace {
		margin-left: 0px;
	}
}

/* IE対応 */
@media all and (-ms-high-contrast: none) {
	.contents__main--mosikomi {
		margin-top: 50px !important;
	}

	.td-isIE {
		position: static;
	}

	.width-name {
		width: 214px !important;
	}
}
</style>